import { FEED_TOPGIOCATE, feedTopGiocateActionType, TopGiocate } from './types';

export const feedTopGiocate = (payload: TopGiocate): feedTopGiocateActionType => ({
  type: FEED_TOPGIOCATE,
  payload,
});
